import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetLogin = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LOGIN_USER_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetLoginAction(data.users));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetLogin as SetGetLogin
}